(() => {
  'use strict';
  const VERSION = '2026-08-17-ui-v30';
  const SECTION = '.faire-dawn-header-section';
  if (window.__ddUiV30 === VERSION) return;
  window.__ddUiV30 = VERSION;

  function menuTrigger(section) {
    return section?.querySelector('[data-faire-open-drawer], [data-faire-menu-trigger], .faire-site-header__menu-toggle, button[aria-controls*="drawer"]');
  }

  function clean(section) {
    if (!(section instanceof HTMLElement)) return;
    const menu = section.querySelector('.ddmm22');
    if (!menu) return;
    menu.querySelectorAll('.dd-mobile-social-dock').forEach(node => node.remove());
    menu.querySelectorAll('.ddmm22__stage .ddmm22__social').forEach(node => node.remove());
    const rails = Array.from(menu.querySelectorAll(':scope > .ddmm27__social'));
    if (rails.length > 1) rails.slice(1).forEach(node => node.remove());
    if (rails[0] && rails[0] !== menu.lastElementChild) menu.appendChild(rails[0]);
    menu.querySelectorAll(':scope > .ddmm22__tabs').forEach(node => node.remove());
  }

  function bindDock(section) {
    if (!(section instanceof HTMLElement) || section.dataset.ddv30DockBound === '1') return;
    section.dataset.ddv30DockBound = '1';
    document.addEventListener('click', event => {
      const target = event.target instanceof Element ? event.target : null;
      const dock = target?.closest('.faire-site-header__bottom-dock, [data-bottom-dock]');
      if (!dock) return;
      const control = target.closest('button,a');
      if (!control) return;
      const label = `${control.getAttribute('aria-label') || ''} ${control.textContent || ''}`.toLocaleLowerCase('tr-TR');
      if (!label.includes('menü') && !label.includes('menu')) return;
      const trigger = menuTrigger(section);
      if (trigger instanceof HTMLElement && trigger !== control) {
        event.preventDefault();
        trigger.click();
      }
    }, true);
  }

  let raf = 0;
  function queue() {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      document.querySelectorAll(SECTION).forEach(section => {
        clean(section);
        bindDock(section);
      });
    });
  }

  function start() {
    queue();
    const observer = new MutationObserver(queue);
    document.querySelectorAll(SECTION).forEach(section => observer.observe(section,{subtree:true,childList:true}));
    document.addEventListener('shopify:section:load', queue);
    setTimeout(queue,120);
    setTimeout(queue,420);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start, {once:true})
    : start();
})();
